function generateContent(priceContainer, rrpPrice, regularPrice) {
    priceContainer.classList.toggle('price-container-ab-test');
    rrpPrice.classList.replace('rrp', 'rrp-ab-test');
    const rrpContainer = document.createElement('div');
    rrpContainer.id = 'rrp-container';
    rrpContainer.classList = 'rrp-container';
    const rrpLabel = document.createElement('span');
    rrpLabel.id = 'rrp-label';
    rrpLabel.classList = 'rrp-label';
    rrpLabel.innerText = 'New RRP ';

    rrpPrice.innerText = rrpPrice.innerText.replace('New RRP ', '');
    rrpContainer.append(rrpLabel);
    rrpContainer.append(rrpPrice);
    priceContainer.appendChild(rrpContainer);


    const priceSaving = document.createElement('span');
    priceSaving.id = 'price-saving';
    priceSaving.classList = 'price-saving';

    regularPrice.prepend(priceSaving);

    document.addEventListener("ab:update-saving", function (event) {
        const rrp = parseInt(event.detail.rrpPrice);
        const price = parseInt(event.detail.price);
        if (rrp && (rrp > price)) {
            let savingsPercentage = Math.round(((rrp - price) / rrp) * 100);
            if (savingsPercentage > 0) {
                priceSaving.innerText = `-${savingsPercentage}%`;
                priceSaving.classList.remove('hidden');
                rrpPrice.classList.add('rrp-price-line-through');
            }
        } else if ((rrp && rrp <= price)) {
            priceSaving.classList.add('hidden');
            rrpPrice.classList.remove('rrp-price-line-through');
        }
    });
}

document.addEventListener('DOMContentLoaded', async function () {
    if (!(await abTests.evaluatePriceSaving())) {
        return;
    }
    const priceSelectors = [
        "product-info .price .price__container",
        "product-info .price-mob-container .price .price__container"
    ];

    priceSelectors.forEach(selector => {
        const priceContainer = document.querySelector(selector);
        if (!priceContainer) {
            return;
        }

        const regularPrice = priceContainer.querySelector('.price__regular');
        const rrpPrice = priceContainer.querySelector('.rrp');
        generateContent(priceContainer, rrpPrice, regularPrice);
    });
});